<template lang="pug">
UiSelect(
  @update:modelValue="onDigiaFileSelect"
  :modelValue="computedModelValue"
  :options="getData"
  :multiselect="multiselect"
  object
  :closeOnSelect="false"
)
</template>

<script>
import ApiDigiaFiles from "@/api/digia_files.js";

export default {
  emits: ["update:modelValue"],

  props: {
    modelValue: {
      type: Array,
      default: null,
    },
    multiselect: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: Number,
      required: true,
    },
    dateStart: {
      type: String,
      required: true,
    },
    dateEnd: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filesMap: new Map(),
    };
  },

  computed: {
    computedModelValue() {
      return (
        this.modelValue?.map((fileId) => ({
          value: fileId,
          label: this.filesMap.get(fileId) || fileId,
        })) || []
      );
    },
  },
  methods: {
    async getData(params) {
      const response = await ApiDigiaFiles.fetchAll(
        {
          company_id: this.companyId,
          date_start: this.dateStart,
          date_end: this.dateEnd,
          search: params.search || undefined,
          page: params.page,
          per_page: params.itemsPerPage,
        },
        {
          signal: params.abortController.signal,
        },
      );

      const items = response.data.digia_files.map(({ id, filename }) => {
        this.filesMap.set(id, filename);
        return {
          label: filename,
          value: id,
        };
      });

      return {
        items,
      };
    },
    onDigiaFileSelect(event) {
      this.$emit(
        "update:modelValue",
        event.map((item) => item.value), // emit the array of ids'
      );
    },
  },
};
</script>
